import { render, staticRenderFns } from "./HousesCards.vue?vue&type=template&id=1333dce6&scoped=true&"
import script from "./HousesCards.vue?vue&type=script&lang=js&"
export * from "./HousesCards.vue?vue&type=script&lang=js&"
import style0 from "./HousesCards.vue?vue&type=style&index=0&id=1333dce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333dce6",
  null
  
)

export default component.exports